class localStorageCacheService {
  public setData(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getData(key: string, defaultValue?: any) {
    const value = localStorage.getItem(key);
    const dateTimeReviver = (_jsonKey: string, jsonValue: any) => {
      if (
        typeof jsonValue === 'string' &&
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(jsonValue)
      ) {
        return new Date(jsonValue);
      }
      return jsonValue;
    };

    return value ? JSON.parse(value, dateTimeReviver) : defaultValue;
  }

  public removeData(key: string) {
    localStorage.removeItem(key);
  }
}

const cache = new localStorageCacheService();

export default cache;
